import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useQuery from '../../../custom-hooks/useQuery';
import { SubmitApprovalViaMail } from '../../../services/attendance-change';
import { Container, Typography, Box, Paper } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material'; // Import from @mui/icons-material
import Approveimg from '../../../assets/images/Approvd.png' 
import Deniedimg from '../../../assets/images/Denied.png' 

export const ThankyouPage = () => {
  const [message, setMessage] = useState('');
  const [success,setsucess] = useState(false);
  let { ftoId } = useParams();
  let query = useQuery();
  var viewValue = query.get("case");
  
  let userId, isApprove;
  
  if (viewValue) {
    userId = viewValue.split('?').find(part => part.startsWith('userId=')).split('=')[1];
    isApprove = viewValue.split('?').find(part => part.startsWith('Approve=')).split('=')[1];
    viewValue = viewValue.split('?')[0];
  }

  const SubmitApproval = async () => {
    const data = {
      ftoId: Number(ftoId),
      isApprove: isApprove,
      note: "Approved",
      userId: userId
    };
    
    try {
      const response = await SubmitApprovalViaMail(data);
      if (response.status === 200) {
        if(isApprove === 'true'){
        setMessage("FTO Approved successfully");
        }
        else{
          setMessage("FTO Denied successfully");
        }
        setsucess(true);
      } else {
        setMessage("FTO is not submitted");
      }
    } catch (error) {
      setMessage("An error occurred while submitting FTO");
      setsucess(false);
    }
  }

  useEffect(() => {
    if (userId && isApprove) {
      SubmitApproval();
    }
  }, []);  
  
  return (
    <>
      {success && (
        isApprove === 'true' ? (
          <img src={Approveimg} alt="ss_white_img" height="100%" width="100%" />
        ) : (
          <img src={Deniedimg} alt="ss_white_img" height="100%" width="100%" />
        )
      )}
    </>
  );
}
